import { Cpu, Sofa, Car, Shirt, Bike, Gem, Flower2, Baby, Wrench, LayoutGrid } from "lucide-react";

export const CAT_ICONS = { Cpu, Sofa, Car, Shirt, Bike, Gem, Flower2, Baby, Wrench, LayoutGrid };

export const CategoryIcon = ({ name, className }) => {
  const Icon = CAT_ICONS[name] || LayoutGrid;
  return <Icon className={className} />;
};

export const catLabel = (cat, lang) => (cat ? (lang === "en" ? cat.label_en : cat.label_it) : "");
